import { render } from "./UTIPanelSelectedTests.vue?vue&type=template&id=40df36bc"
import script from "./UTIPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./UTIPanelSelectedTests.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/testInfo/selectedTestsPreview/UTIPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40df36bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40df36bc', __exports__)) {
    console.log('reload')
    api.reload('40df36bc', __exports__)
  }
  
  module.hot.accept("./UTIPanelSelectedTests.vue?vue&type=template&id=40df36bc", () => {
    console.log('re-render')
    api.rerender('40df36bc', render)
  })

}


export default __exports__